<template>
  <div class="d-flex justify-space-between">
    <GradeClassStudentSelect
      disableGradeSelect
      disableClassSelect
      @changed="gradeClassStudentChange"
      :studentCol="{ cols: 12, sm: 12, md: 12 }"
    />
    <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
  </div>
</template>
<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { mapActions } from 'vuex'
export default {
  components: { GradeClassStudentSelect },
  data: () => ({ student: null }),
  methods: {
    ...mapActions({ search: 'studentSurvey/search' }),
    gradeClassStudentChange(val) {
      this.student = val.student
    },
    async onFilterChanged() {
      if (this.student) {
        await this.search({ survey: this.$route.params.id, _sort: 'createdAt:DESC', student: this.student.id })
      } else {
        await this.search({ survey: this.$route.params.id, _sort: 'createdAt:DESC' })
      }
    },
  },
}
</script>
